import { useState, useEffect } from 'react'
import { Package, Image as ImageIcon } from 'lucide-react'
import { getImageUrl } from '../utils/apiUrl'

const ProductImage = ({ 
  imageUrl, 
  alt, 
  className = "w-full h-full object-cover",
  fallbackIcon = Package,
  fallbackIconSize = "h-12 w-12",
  showFallback = true,
  showLoading = true
}) => {
  const [imageError, setImageError] = useState(false)
  const [imageLoading, setImageLoading] = useState(true)
  const [currentImageUrl, setCurrentImageUrl] = useState('')

  const FallbackIcon = fallbackIcon

  // Générer l'URL WebP et l'URL originale
  useEffect(() => {
    if (!imageUrl) return

    const originalUrl = getImageUrl(imageUrl)
    // Créer l'URL WebP dans le dossier optimized
    const webpUrl = originalUrl.replace(/\/images\/products\//, '/images/products/optimized/').replace(/\.(jpg|jpeg|png)$/i, '.webp')
    
    // Essayer d'abord le WebP, puis l'original en cas d'échec
    setCurrentImageUrl(webpUrl)
  }, [imageUrl])

  const handleImageError = () => {
    // Si c'est une WebP qui a échoué, essayer l'original
    if (currentImageUrl.includes('.webp')) {
      const originalUrl = getImageUrl(imageUrl)
      setCurrentImageUrl(originalUrl)
      setImageError(false) // Reset l'erreur pour essayer l'original
      return
    }
    
    // Si l'original a aussi échoué
    setImageError(true)
    setImageLoading(false)
  }


  const handleImageLoad = () => {
    setImageLoading(false)
  }

  // Si pas d'URL d'image ou erreur de chargement
  if (!imageUrl || imageError) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center bg-gray-100">
        {showFallback && (
          <>
            <FallbackIcon className={`${fallbackIconSize} text-gray-400 mb-2`} />
            <span className="text-xs text-gray-500">Aucune image</span>
          </>
        )}
      </div>
    )
  }

  return (
    <div className="relative w-full h-full group">
      {imageLoading && showLoading && (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-gray-100 z-10">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500 mb-2"></div>
          <span className="text-xs text-gray-500">Chargement...</span>
        </div>
      )}
      <img
        src={`${currentImageUrl}?v=${Date.now()}`}
        alt={alt}
        className={`${className} ${imageLoading ? 'opacity-0' : 'opacity-100'} transition-all duration-300 group-hover:scale-105`}
        onError={handleImageError}
        onLoad={handleImageLoad}
      />
      
      
      {/* Overlay avec icône d'image au hover */}
      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
        <ImageIcon className="h-8 w-8 text-white" />
      </div>
    </div>
  )
}

export default ProductImage
